import { cn } from "@/lib/utils";
import { Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmptyState({ icon: Icon = Inbox, title, description, actionLabel, onAction, className }) {
    return (
        <div className={cn("flex flex-col items-center justify-center py-16 px-4 text-center", className)} data-testid="empty-state">
            <div className="w-12 h-12 rounded-full bg-muted/60 border border-border flex items-center justify-center mb-3">
                <Icon className="w-5 h-5 text-muted-foreground" strokeWidth={1.5} />
            </div>
            <h3 className="font-serif text-xl text-foreground">{title}</h3>
            {description && <p className="text-[13px] text-muted-foreground mt-1.5 max-w-sm">{description}</p>}
            {onAction && actionLabel && <Button onClick={onAction} className="mt-4" size="sm" data-testid="empty-state-action">{actionLabel}</Button>}
        </div>
    );
}
